
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 48 48","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"currentColor","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24zm0-3C12.402 45 3 35.598 3 24S12.402 3 24 3s21 9.402 21 21-9.402 21-21 21z","fill-rule":"nonzero"}}),_c('path',{attrs:{"d":"M9.587 34.497C11.92 27.93 17.57 23.5 24 23.5c6.43 0 12.08 4.43 14.413 10.997a1.5 1.5 0 01-2.826 1.005C33.66 30.078 29.096 26.5 24 26.5s-9.66 3.578-11.587 9.002a1.5 1.5 0 01-2.826-1.005z","fill-rule":"nonzero"}}),_c('circle',{attrs:{"cx":"16.5","cy":"17.5","r":"2.5"}}),_c('circle',{attrs:{"cx":"31.5","cy":"17.5","r":"2.5"}})])])
          )
        }
      }
    